import { Card, Form, Input, Select } from 'antd';

export const WorkflowTemplateSettingsSection = () => {
  const formItemLayout = {
    labelCol: { flex: '140px' },
    wrapperCol: { flex: 'auto' },
  };

  return (
    <Card size="small" title="Workflow Settings">
      <Form.Item
        label="Workflow Type"
        name={['workflow', 'workflow_type']}
        {...formItemLayout}
      >
        <Input size="small" placeholder="single_step" />
      </Form.Item>

      <Form.Item
        label="Required Inputs"
        name={['workflow', 'required_inputs']}
        {...formItemLayout}
      >
        <Select
          size="small"
          mode="tags"
          tokenSeparators={[',']}
          placeholder="e.g. service_request_id, org_uuid"
        />
      </Form.Item>
    </Card>
  );
};
